'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectCmsPath = undefined;

var _selectors = require('redux/saga/selectors');

var _bound = require('redux/saga/entities/bound');

var selectCmsPath = exports.selectCmsPath = function selectCmsPath(state) {
  var path = (0, _selectors.pathSelector)(state);
  return _bound.cms.defaultKey(null, path);
};